import { gql } from 'graphql-tag';
import {
  GIFT_CARD_FRAGMENT,
  MEMBERSHIPPLAN_FRAGMENT,
  MEMBER_FRAGMENT,
  NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT,
} from '../fragments';

/**
 * 更新用户信息
 */
export const fetchUpdateUserDocument = gql`
  mutation updateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
    }
  }
`;

/**
 * 查询会员列表数据
 */
export const fetchMembershipPlansDocument = gql`
  query membershipPlans($options: MembershipPlanListOptions) {
    membershipPlans(options: $options) {
      items {
        ...MembershipPlan
      }
      totalItems
    }
  }
  ${MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 查询会员详情数据
 */
export const fetchMembershipPlanDocument = gql`
  query membershipPlan($membershipPlanId: ID!, $options: MembershipPlanListOptions) {
    membershipPlan(membershipPlanId: $membershipPlanId, options: $options) {
      ...MembershipPlan
    }
  }
  ${MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 查询用户会员信息
 */
export const fetchGetUserMemberDocument = gql`
  query getUserMember {
    getUserMember {
      ...Member
    }
  }
  ${MEMBER_FRAGMENT}
`;

/**
 * 激活会员
 */
export const fetchMembershipCardActivationDocument = gql`
  mutation membershipCardActivation($input: ActivateMembershipCardInput!) {
    membershipCardActivation(input: $input) {
      ...Member
    }
  }
  ${MEMBER_FRAGMENT}
`;

/**
 * 购买会员
 */
// export const fetchPurchaseMembershipDocument = gql`
//   mutation purchaseMembership($membershipPlanId: ID!, $paymentType: WeChatPaymentType) {
//     purchaseMembership(membershipPlanId: $membershipPlanId, paymentType: $paymentType) {
//       status
//       appId
//       timeStamp
//       nonceStr
//       package
//       signType
//       paySign
//     }
//   }
// `;

/**
 * 使用会员优惠
 */
export const fetchApplyMemberDocument = gql`
  mutation applyMember($orderId: ID) {
    applyMember(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 取消使用会员优惠
 */
export const fetchCancelMemberDocument = gql`
  mutation cancelMember($orderId: ID) {
    cancelMember(orderId: $orderId) {
      id
    }
  }
`;

/**
 * 获取最大优惠的会员卡信息
 */
export const fetchMaxDiscountMembershipPlanDocument = gql`
  query maxDiscountMembershipPlan {
    maxDiscountMembershipPlan {
      ...MembershipPlan
    }
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
`;

/**
 * 获取购卡记录
 */
export const fetchMembershipOrdersDocument = gql`
  query membershipOrders($options: MembershipOrderListOptions) {
    membershipOrders(options: $options) {
      items {
        id
        createdAt
        updatedAt
        code
        state
        paymentMethod
        amount
        metadata
        payTime
        member {
          ...Member
        }
        membershipPlan {
          ...MembershipPlan
        }
      }
      totalItems
    }
  }
  ${NOT_COUPON_MEMBERSHIPPLAN_FRAGMENT}
  ${MEMBER_FRAGMENT}
`;

/**
 * 获取礼品卡数据
 */
export const fetchMemberGiftCardDocument = gql`
  query giftCard($giftCardId: ID!) {
    giftCard(giftCardId: $giftCardId) {
      ...GiftCard
    }
  }
  ${GIFT_CARD_FRAGMENT}
`;

/**
 * 获取用户持有的礼品卡数据
 */
export const fetchUserMemberGiftCardDocument = gql`
  query userGiftCard {
    userGiftCard {
      id
    }
  }
`;

/**
 * 购买礼品卡
 */
export const fetchPurchaseGiftCardDocument = gql`
  mutation purchaseGiftCard($giftCardId: ID!, $paymentType: WeChatPaymentType) {
    purchaseGiftCard(giftCardId: $giftCardId, paymentType: $paymentType) {
      status
      appId
      timeStamp
      nonceStr
      package
      signType
      paySign
    }
  }
`;

/**
 * 获取用户礼品卡下单数据（列表）
 */
export const fetchUserMemberGiftCardOrdersDocument = gql`
  query giftCardOrders(
    $giftCardId: ID
    $phone: String
    $distributorId: ID
    $options: GiftCardOrderListOptions
  ) {
    giftCardOrders(
      giftCardId: $giftCardId
      phone: $phone
      distributorId: $distributorId
      options: $options
    ) {
      items {
        id
        createdAt
        updatedAt
        code
        paymentMethod
        amount
        state
        metadata
        giftCard {
          ...GiftCard
        }
        payTime
        giftCardReturns {
          id
          price
        }
      }
      totalItems
    }
  }
  ${GIFT_CARD_FRAGMENT}
`;

/**
 * 根据会员卡id查询商品数据
 */
export const fetchProductVariantToMembershipIdDocument = gql`
  query productVariantToMembershipId($membershipId: ID!) {
    productVariantToMembershipId(membershipId: $membershipId) {
      id
      price
      productId
    }
  }
`;

/**
 * 查询用户虚拟币余额数据
 */
export const fetchVirtualCurrencyBalanceDocument = gql`
  query getVirtualCurrencyBalance($virtualCurrencyCode: VirtualCurrencyCode!) {
    getVirtualCurrencyBalance(virtualCurrencyCode: $virtualCurrencyCode)
  }
`;

/**
 * 获取虚拟币明细
 */
export const fetchVirtualCurrencyHistoryDocument = gql`
  query getVirtualCurrencyHistory(
    $virtualCurrencyCode: VirtualCurrencyCode!
    $options: VirtualCurrencyHistoryListOptions
  ) {
    getVirtualCurrencyHistory(virtualCurrencyCode: $virtualCurrencyCode, options: $options) {
      items {
        id
        createdAt
        amount
        sourceType
        sourceValue
        remark
        symbolType
      }
      totalItems
    }
  }
`;

/**
 * 获取购物金配置
 */
export const fetchShoppingCreditsConfigDocument = gql`
  query getShoppingCreditsConfig {
    getShoppingCreditsConfig {
      id
      customPageId
      shoppingCreditsRule
      channelId
    }
  }
`;
